import { Link, useLocation, useNavigate } from 'react-router-dom';
import { COMPANY_INFO, SERVICES } from '../constants/services';
import quanturamaLogo from '../assets/Qunaturama-logo-black.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    // If not on home page, navigate to home first
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const offset = 80;
          const elementPosition = element.offsetTop - offset;
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 80;
        const elementPosition = element.offsetTop - offset;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  const navItems = [
    { id: 'home', name: 'Home' },
    { id: 'services', name: 'Services' },
    { id: 'portfolio', name: 'Portfolio' },
    { id: 'about', name: 'About', route: '/about' },
    { id: 'contact', name: 'Contact', route: '/contact' }
  ];

  return (
    <footer className="footer" id="contact">
      <div className="footer-content">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-brand-header">
              <div className="footer-brand-mark">
                <img src={quanturamaLogo} alt="Quanturama logo" />
              </div>
              <h2 className="footer-brand-name">{COMPANY_INFO.name}</h2>
            </div>
            <p className="footer-tagline">{COMPANY_INFO.tagline}</p>
          </div>

          <div className="footer-links-grid">
            <div className="footer-column">
              <h3 className="column-title">Quick Links</h3>
              <ul className="footer-links">
                {navItems.map((link) => (
                  <li key={link.id}>
                    {link.route ? (
                      <Link to={link.route}>{link.name}</Link>
                    ) : (
                      <a
                        href={`#${link.id}`}
                        onClick={(e) => { e.preventDefault(); scrollToSection(link.id); }}
                      >
                        {link.name}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="column-title">Services</h3>
              <ul className="footer-links">
                {SERVICES.slice(0, 4).map((service) => (
                  <li key={service.id}>
                    <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>
                      {service.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="column-title">Products</h3>
              <ul className="footer-links">
                <li><a href="https://pheme.quanturama.com" target="_blank" rel="noopener noreferrer">PHEME — Market Intelligence</a></li>
                <li><a href="https://agoravalleys.com" target="_blank" rel="noopener noreferrer">Agora Valleys — Agent Marketplace</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="column-title">Connect</h3>
              <ul className="footer-links">
                <li><a href="mailto:hello@quanturama.com">Email Us</a></li>
                <li><a href="https://t.me/QSatCryptoSignal" target="_blank" rel="noopener noreferrer">Telegram Channel</a></li>
                <li><a href="https://t.me/QuanturamaLobby" target="_blank" rel="noopener noreferrer">Community Lobby</a></li>
                <li><a href="https://www.linkedin.com/company/quanturama/" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-legal">
            <p>&copy; {currentYear} {COMPANY_INFO.name}. All rights reserved.</p>
            <div className="legal-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/disclaimer">Disclaimer</Link>
              <a
                href="https://prima.quanturama.com"
                style={{ fontFamily: 'monospace', color: 'inherit', textDecoration: 'none', opacity: 0.45 }}
              >{'{0}'}</a>
            </div>
          </div>
        </div>
      </div>

      {/* Placeholder for analytics and schema */}
      <div id="analytics-placeholder"></div>
      <div id="schema-placeholder"></div>
    </footer>
  );
};

export default Footer;
